import { render, staticRenderFns } from "./index_choose.vue?vue&type=template&id=fe59e654&scoped=true&"
import script from "./index_choose.vue?vue&type=script&lang=js&"
export * from "./index_choose.vue?vue&type=script&lang=js&"
import style0 from "./index_choose.vue?vue&type=style&index=0&id=fe59e654&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe59e654",
  null
  
)

export default component.exports